<div>
  <form #f="ngForm" (ngSubmit)="onSaveEmployeeDetailData()" novalidate>
    <div class="row m-0 mt-1 formborder">
      <div class="col-md-4 p-1">
        <span>Employee Name </span>
        <input
          required
          type="text"
          #refProductName="ngModel"
          name="EmployeeName"
          id="EmployeeName"
          placeholder="Employee Name"
          [(ngModel)]="EmployeeName"
          class="form-control input-text-css"
          disabled
        />
      </div>
      <div class="col-md-3 p-1">
        <span> Designation </span>
        <select
          name="SelectRoleId"
          id="SelectRoleId"
          disabled
          [(ngModel)]="SelectRoleId"
          class="form-control input-text-css"
        >
          <option
            *ngFor="let rolesDropdownData of RolesDropdownData"
            [value]="rolesDropdownData.RoleId"
          >
            {{ rolesDropdownData.Role_Name }}
          </option>
        </select>
      </div>
      <div class="col-md-3 p-1">
        <span>Reporting Manager </span>
        <select
          name="EmpManagerId"
          id="EmpManagerId"
          disabled
          [(ngModel)]="EmpManagerId"
          class="form-control input-text-css"
        >
          <option
            *ngFor="let reportingManager of ReportingManagerDropdown"
            [value]="reportingManager.EmpId"
          >
            {{ reportingManager.EmpName }}
          </option>
        </select>
      </div>
      <div class="col-md-2 p-1 mt-3">
        <button
          type="button"
          (click)="onNewBranchAssign()"
          *ngIf="AssignBranchList?.length > 0"
          class="btn font-size-12 button-btn"
          [class.spinner]="loading"
        >
          Branch Assign
        </button>
      </div>
    </div>

    <div>
      <div class="table-responsive simple-table mt-2">
        <table class="table font-size-12">
          <thead>
            <tr>
              <th>#</th>
              <th>Branch Name</th>
              <th>Branch Code</th>
              <th>District</th>
              <th>Tehsil</th>
              <th>
                <mat-checkbox class="example-margin"
                              name="SelectAll"
                              id="SelectAll"
                              [(ngModel)]="SelectAll"
                              (change)="onChangeSelectAll()">
                </mat-checkbox>
                Select All
              </th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let assignBranch of BranchesList; let i = index"
              class="font-size-11"
            >
              <td>{{ i + 1 }}</td>
              <td>{{ assignBranch.Branch_Name }}</td>
              <td>{{ assignBranch.Branch_Code }}</td>
              <td>{{ assignBranch.District_Name }}</td>
              <td>{{ assignBranch.Tehsil_Name }}</td>
              <td>
                <mat-checkbox
                  [checked]="assignBranch.isActiveSelect"
                  [disabled]="assignBranch.isDisable"
                  id="checkbox-Branch-{{ i }}"
                  name="checkbox-Branch-{{ i }}"
                  (change)="onChangeAssignBranch($event, assignBranch.BranchId)"
                >
                </mat-checkbox>
              </td>
              <td>
                <i
                  *ngIf="assignBranch.BranchAlradyAssigned"
                  (click)="onDeleteAssignBranch(assignBranch.BranchId)"
                  class="fa fa-trash style-delete"
                  aria-label="true"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!--<span class="font-size-12"> <strong> Assign Process</strong> </span>
      <div class="table-responsive mt-2" style="max-height: 195px;">
        <table class="table font-size-12">
          <thead>
            <tr>
              <th> # </th>
              <th> Process Name </th>
              <th> Select </th>
              <th> Delete </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let assignProcess of LoanProcessList; let i = index;" class="font-size-11">
              <td> {{i+1}} </td>
              <td> {{assignProcess.Process_Name}} </td>
              <td>
                <mat-checkbox [checked]="assignProcess.isActiveSelect" [disabled]="assignProcess.isDisable"
                  id="checkbox-Process-{{i}}" name="checkbox-Process-{{i}}"
                  (change)="onChangeAssignProcess($event,assignProcess.ProcessId)">
                </mat-checkbox>
              </td>
              <td> <i *ngIf="assignProcess.ProcessAlradyAssigned" class="fa fa-minus-circle font-size-15"
                  (click)="onDeleteAssignProcess(assignProcess.EmpProcessId)" style="color:red;cursor: pointer;"
                  aria-label="true"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>-->
    </div>
    <div class="text-right mt-2">
      <button
        type="button"
        (click)="onSaveEmployeeDetailData()"
        class="btn font-size-12 button-btn"
        [class.spinner]="loading"
      >
        Save
      </button>
    </div>
  </form>
</div>

<div
  class="modal fade in"
  id="DeleteBranchModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          {{ popupValue }} Branch Assignment
        </h6>
        <button
          type="button"
          (click)="onCloseDeleteBranchModel()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <mat-table
            [dataSource]="dataSource"
            matSort
            matTableExporter
            #exporter="matTableExporter"
            style="height: 190px; max-width: 100%; overflow: auto"
          >
            <ng-container matColumnDef="EmpId">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                style="max-width: 100px"
                *matHeaderCellDef
                >#</mat-header-cell
              >
              <mat-cell
                *matCellDef="let row; let i = index"
                class="grid-cell"
                style="max-width: 100px; max-height: 5px"
              >
                {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Emp_Name">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Emp_Name</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Emp_Name }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Designation">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Designation</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Designation }}
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>

          <mat-paginator
            #paginatorRef
            [pageSizeOptions]="[20, 50]"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>

        <div class="row m-0 mt-2">
          <div class="col-md-12 text-right">
            <button
              type="button"
              (click)="DeleteAllAssignmentBranch()"
              class="btn font-size-12 button-btn"
              [class.spinner]="loading"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="AssignBranchModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          {{ popupValue }} Branch Assignment
        </h6>
        <button
          type="button"
          (click)="onCloseAssignBranchModel()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <form #ff="ngForm" (ngSubmit)="BranchAssignment()" novalidate>
          <div class="row m-0 mt-3">
            <div class="col-md-12 p-1">
              <span> Select Branch </span>
              <select
                required
                name="SelectBranch"
                id="SelectBranch"
                #refSelectBranch="ngModel"
                [(ngModel)]="SelectBranch"
                class="form-control input-text-css"
                [ngClass]="{
                  'is-invalid': ff.submitted && refSelectBranch.invalid,
                  'alert-warning':
                    refSelectBranch.invalid &&
                    (refSelectBranch.dirty ||
                      refSelectBranch.touched ||
                      refSelectBranch.untouched)
                }"
              >
                <option value="">Select Branch</option>
                <option
                  *ngFor="let branch of AssignBranchList"
                  [value]="branch.BranchId"
                >
                  {{ branch.Branch_Name }}
                </option>
              </select>
            </div>
          </div>
          <div class="table-responsive">
            <mat-table
              [dataSource]="dataSourceBranchAssign"
              matSort
              matTableExporter
              #exporter="matTableExporter"
              style="height: 190px; max-width: 100%; overflow: auto"
            >
              <ng-container matColumnDef="EmpId">
                <mat-header-cell
                  mat-sort-header
                  class="grid-header"
                  style="max-width: 100px"
                  *matHeaderCellDef
                  >#</mat-header-cell
                >
                <mat-cell
                  *matCellDef="let row; let i = index"
                  class="grid-cell"
                  style="max-width: 100px; max-height: 5px"
                >
                  {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Emp_Name">
                <mat-header-cell
                  mat-sort-header
                  class="grid-header"
                  *matHeaderCellDef
                  >Emp_Name</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.Emp_Name }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Designation">
                <mat-header-cell
                  mat-sort-header
                  class="grid-header"
                  *matHeaderCellDef
                  >Designation</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.Designation }}
                </mat-cell>
              </ng-container>

              <mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: displayedColumns"
              ></mat-row>
            </mat-table>

            <mat-paginator
              #paginatorRef
              [pageSizeOptions]="[20, 50]"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
          <div class="row m-0 mt-2">
            <div class="col-md-12 text-right">
              <button
                type="button"
                (click)="BranchAssignment()"
                [disabled]="!ff.form.valid"
                class="btn font-size-12 button-btn"
                [class.spinner]="loading"
              >
                Assign
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
